import { Navigate, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { isTokenExpired, parseJwt } from '@utils/jwt';

const PrivateRoute = () => {
  const [isAdmin, setIsAdmin] = useState(null);
  const [isExpired, setIsExpired] = useState(null);

  // const checkToken = async () => {
  //   try {
  //     await api.get('/api/auth/token').then((res) => {
  //       console.log('PrivateRoute :: res');
  //       console.log(res);

  //       if (res.status === 200) {
  //         // console.log("PrivateRoute :: true")
  //         setValid(true);
  //       } else {
  //         // console.log("PrivateRoute :: false")
  //         setValid(false);
  //       }
  //     });
  //   } catch (err) {
  //     // console.log("PrivatteRoute :: err :: false")
  //     setValid(false);
  //   }
  // };

  const checkAdmin = async () => {
    try {
      // 토큰 분석
      const token = localStorage.getItem('token');
      const parsed = token ? parseJwt(token) : null;
      const isAdmin = parsed?.isAdmin === 1 ? true : false;

      // 토큰 만료 여부 확인
      const isExpired = isTokenExpired(token);

      // 토큰 만료 이용하여 관리자 여부 확인
      if (isExpired) {
        setIsExpired(true);
      } 
      else {
        setIsAdmin(isAdmin);
      }
    } catch (err) {
      setIsAdmin(false);
    }
  };

  useEffect(() => {
    checkAdmin();
  }, []);

  // 토큰 만료 시 로그인 페이지로 이동
  if (isExpired) {
    return <Navigate to="/" replace />;
  }

  // 관리자 여부 확인 : 참일 경우
  if (isAdmin === true) {
    return <Outlet />;
  }

  // 관리자 여부 확인 : 거짓일 경우
  if (isAdmin === false) {
    return <Navigate to="/project/projectList" replace />;
  }

  return <></>;
};

export default PrivateRoute;
